import './ModuleLoaderCard.scss';
import Skeleton from '@trackman/web-shared-components/components/LoadingPlaceholder/Skeleton';

export const ModuleLoaderCard = () => {
  return (
    <div className='module-loader-card'>
      <Skeleton height={228} sx={{ borderBottomRightRadius: 0, borderBottomLeftRadius: 0 }} />
      <div className='loading-card-content'>
        <Skeleton width={90} height={13} />
        <div>
          <Skeleton width={250} height={13} />
          <Skeleton width={200} height={13} />
        </div>
        <div className='divider'></div>
        <div>
          <Skeleton width={60} height={13} />
          <Skeleton width={60} height={13} />
          <Skeleton width={60} height={13} />
        </div>
      </div>
    </div>
  );
};
